import { render, staticRenderFns } from "./MarketingBrief.vue?vue&type=template&id=d0608296&scoped=true&"
import script from "./MarketingBrief.vue?vue&type=script&lang=js&"
export * from "./MarketingBrief.vue?vue&type=script&lang=js&"
import style0 from "./MarketingBrief.vue?vue&type=style&index=0&id=d0608296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0608296",
  null
  
)

export default component.exports